import React, { FC, memo, useEffect, useRef } from 'react';
import { PageLoader } from 'features/PageLoader';

export const LoginProcessPage: FC = memo(() => {
  const hasPostedRef = useRef(false);

  useEffect(() => {
    if (hasPostedRef.current) return;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get('access_token');

    if (token && window.opener) {
      window.opener.postMessage({ access_token: token }, window.location.origin);
      hasPostedRef.current = true;
      window.close();
    }
  }, []);

  return <PageLoader />;
});
